import React from "react";
import styled from "styled-components";
import { useUser } from "@auth0/nextjs-auth0/client";
import { useRouter } from "next/router";

import useBanners from "@/hooks/useBanners";
import AuthHeader from "./AuthHeader";
import Header from "./Header";
import Footer from "./Footer";

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  const { pathname } = useRouter();
  const { user } = useUser();
  const { banners, openBannerCount } = useBanners();

  if (["/download", "/user/create", "/user/adesacom/create"].includes(pathname)) {
    return <>{children}</>;
  }

  if (!user || pathname === "/") {
    return (
      <LayoutWrapper>
        <Header />
        {children}
        <Footer />
      </LayoutWrapper>
    );
  }

  return (
    <LayoutWrapper>
      <AuthHeader />
      {banners}
      <ContentWrapper $openBannerCount={openBannerCount}>
        {children}
      </ContentWrapper>
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div`
  overflow: hidden;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-flow: column;
`;

const ContentWrapper = styled.div<{ $openBannerCount: number }>`
  --content-height: ${({ $openBannerCount }) =>
    $openBannerCount
      ? `calc(100vh - (var(--header-height) + (var(--banner-height) * ${$openBannerCount})))`
      : "calc(100vh - var(--header-height))"};
  height: var(--content-height);
  overflow: auto;
`;

export default Layout;
